module.exports = __webpack_public_path__ + "static/assets/080daf764301621715e1072743fa7dd2.png";